/**
 * Animation XP qui flotte vers le haut
 */
import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';

const XPAnimation = ({ xp, show, onComplete }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ y: 0, opacity: 1 });
  
  useEffect(() => {
    if (!show || !xp) return;
    
    setVisible(true);
    setPosition({ y: 0, opacity: 1 });
    
    // Animation
    let frame = 0;
    const animate = () => {
      frame++;
      const y = frame * 2;
      const opacity = Math.max(0, 1 - frame / 30);
      
      setPosition({ y, opacity });
      
      if (frame < 30) {
        requestAnimationFrame(animate);
      } else {
        setVisible(false);
        if (onComplete) onComplete();
      }
    };
    
    requestAnimationFrame(animate);
  }, [show, xp, onComplete]);
  
  if (!visible) return null;
  
  return (
    <div 
      className="fixed top-1/2 left-1/2 transform -translate-x-1/2 z-50 pointer-events-none"
      style={{
        transform: `translate(-50%, calc(-50% - ${position.y}px))`,
        opacity: position.opacity
      }}
    >
      <div className="flex items-center gap-2 bg-yellow-400 text-yellow-900 px-4 py-2 rounded-full font-bold text-xl shadow-lg">
        <Zap className="w-6 h-6" fill="currentColor" />
        +{xp} XP
      </div>
    </div>
  );
};

export default XPAnimation;
